import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocUtilsService {
  private documentsNotSupportedByDocViewer: string[] = [
    //'DB', // big 5 document
    //'PD', //PUBLIC_DOCUMENT
    //'B5',//Publication big 5
    'EN', //enquiry
  ];

  constructor() {}

  public isDocNotSupportedByViewer(uniqueNumber: string): boolean {
    if (uniqueNumber) {
      for (const code of this.documentsNotSupportedByDocViewer) {
        if (
          uniqueNumber.startsWith(code) &&
          !(uniqueNumber.indexOf('_') > -1)
        ) {
          return true;
          break;
        }
      }
    }
    return false;
  }

  public getGenesisRedirectUrl(uniqueNumber: string, version: string): string {
    let redirectUrl = '/product/documents/' + uniqueNumber;
    if (!version || version !== 'this') {
      redirectUrl = redirectUrl + '/latest';
      //console.log('add latest version');
    }

    return redirectUrl;
  }
}
